import React from 'react';

import { Image } from 'src/shared/components/ui';

interface AppImageProps {
  src?: string;
  alt?: string;
  className?: string;
  id?: string;
}

const GRADIENT_IMAGES = [
  '/images/placeholders/blue.jpg',
  '/images/placeholders/green.jpg',
  '/images/placeholders/purple.jpg',
  '/images/placeholders/red.jpg'
];

function hashString(str: string): number {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }

  return Math.abs(hash);
}

function getImageForId(id: string | undefined): string {
  const index = hashString(id ?? '') % GRADIENT_IMAGES.length;

  return GRADIENT_IMAGES[index];
}

const AppImage: React.FC<AppImageProps> = ({ src, alt, className, id }) => {
  if (!src) {
    const assignedImage = getImageForId(id);

    return (
      <Image
        src={assignedImage}
        alt="No image"
        className={className}
        draggable={false}
      />
    );
  }

  return <Image src={src} alt={alt} className={className} />;
};

export default AppImage;
